import { Link, useLocation } from "react-router-dom";
import logo from "../assets/images/Impact_Logo.png";
import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Heart } from "lucide-react";

const navItems = [
  { name: "Home", path: "/" },
  { name: "About Us", path: "/about" },
  { name: "Our Initiatives", path: "/initiatives" },
  { name: "Capacity Building", path: "/capacity-building" },
  { name: "Team", path: "/team" },
  { name: "Contact", path: "/contact" },
];

const Navbar = () => {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <nav className="bg-white/80 backdrop-blur-md shadow-sm sticky top-0 z-50 font-body">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
        {/* Logo */}
        <Link to="/" className="flex items-center space-x-3">
          <img src={logo} alt="Impact Together Logo" className="h-12 md:h-16 w-auto" />
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center space-x-8">
          {navItems.map((item) => (
            <Link
              key={item.name}
              to={item.path}
              className={`relative text-lg font-medium transition-all duration-200 ${
                location.pathname === item.path
                  ? "text-primary after:absolute after:-bottom-1 after:left-0 after:h-[2px] after:w-full after:bg-primary"
                  : "text-gray-700 hover:text-primary hover:after:w-full after:transition-all after:duration-300 after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-0 after:bg-primary"
              }`}
            >
              {item.name}
            </Link>
          ))}
        </div>

        {/* Mobile Button */}
        <button
          onClick={() => setMobileOpen((prev) => !prev)}
          className="md:hidden focus:outline-none transition-transform duration-300"
        >
          <motion.svg
            className="w-7 h-7 text-gray-700"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            initial={false}
            animate={mobileOpen ? { rotate: 90 } : { rotate: 0 }}
            transition={{ duration: 0.3 }}
          >
            {mobileOpen ? (
              <motion.path
                key="close"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
                initial={{ pathLength: 0 }}
                animate={{ pathLength: 1 }}
              />
            ) : (
              <motion.path
                key="menu"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
                initial={{ pathLength: 0 }}
                animate={{ pathLength: 1 }}
              />
            )}
          </motion.svg>
        </button>
      </div>

      {/* Mobile Nav Slide Down */}
      <AnimatePresence>
        {mobileOpen && (
          <motion.div
            className="md:hidden px-4 pb-6 space-y-4"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.3 }}
          >
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                onClick={() => setMobileOpen(false)}
                className={`block py-2 text-base font-medium ${
                  location.pathname === item.path
                    ? "text-primary font-semibold"
                    : "text-gray-700 hover:text-primary"
                }`}
              >
                {item.name}
              </Link>
            ))}
            <Link
              to="/donate"
              onClick={() => setMobileOpen(false)}
              className="block text-center mt-2 px-4 py-2 text-sm font-semibold text-white bg-secondary hover:bg-secondary/90 transition rounded-full flex items-center justify-center gap-2"
            >
              Donate
              <Heart className="w-4 h-4 text-primary fill-primary animate-pulse" fill="currentColor" />
            </Link>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;
